// client/src/api/cardService.js
import api from './api';

// Fonction pour récupérer toutes les cartes
export const getAllCards = async (params = {}) => {
  try {
    const response = await api.get('/cards', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching all cards:', error);
    return {
      success: false,
      cards: [],
      error: 'Failed to fetch cards'
    };
  }
};

// Fonction pour récupérer les détails d'une carte spécifique
export const getCardDetails = async (cardId) => {
  try {
    const response = await api.get(`/cards/${cardId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching card details:', error);
    return {
      success: false,
      message: 'Card not found'
    };
  }
};

// Fonction pour récupérer les cartes par élément
export const getCardsByElement = async (element) => {
  try {
    const response = await api.get(`/cards/element/${element}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cards by element:', error);
    return {
      success: false,
      cards: []
    };
  }
};

// Fonction pour récupérer la collection de cartes d'un utilisateur
export const getUserCollection = async (userId) => {
  try {
    const response = await api.get(`/cards/collection/${userId || 'current'}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user collection:', error);
    return {
      success: false,
      cards: [],
      error: 'Failed to fetch user collection'
    };
  }
};